import React from 'react';
import { motion } from 'framer-motion';
export function ComparisonTable() {
  return <section className="py-12 md:py-16 bg-cream-dark" data-id="element-37">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-39">
          <h2 className="text-2xl md:text-3xl font-bold text-wood-dark mb-2" data-id="element-40">
            El próximo fin de semana podés seguir improvisando.
          </h2>
          <p className="text-2xl md:text-4xl font-black text-amber-dark font-serif" data-id="element-41">
            O podés tener todo resuelto desde hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}